import { pb, pbUrl } from '../../../shared/api/pocketbase';
import { LeaderBoardEntry, LeaderBoardGroup } from './types';

export interface LeaderBoardFilter {
  year?: string;
  month?: string;
}

export interface LeaderBoardResponse {
  updatedAt: string;
  items: LeaderBoardEntry[];
  groups: LeaderBoardGroup[];
}

export const fetchLeaderBoard = async (filter: LeaderBoardFilter = {}): Promise<LeaderBoardResponse> => {
  const base = pbUrl === '/' ? '' : pbUrl;
  const params = new URLSearchParams();
  if (filter.year) params.set('year', filter.year);
  if (filter.month) params.set('month', filter.month);
  const query = params.toString() ? `?${params}` : '';
  const resp = await fetch(`${base}/api/leaderboard${query}`, {
    headers: { Authorization: pb.authStore.token },
  });

  if (!resp.ok) throw new Error('Failed to fetch leaderboard');

  return resp.json();
};
